export function removeClass(selector, myClass)
{
	  // get all elements that match our selector
      let elements = document.querySelectorAll(selector);

      // remove class from all chosen elements
      for (var i=0; i<elements.length; i++) {
          elements[i].classList.remove(myClass);
      }
}
